import { useEffect, useState } from 'react';
import { CompetencyType } from '../types/Competency';

export const useLocalStorage = (
  storageKey: string,
  fallbackState: Array<CompetencyType>,
) => {
  const [value, setValue] = useState(
    JSON.parse(String(localStorage.getItem(storageKey))) ?? fallbackState,
  );
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }, [value, storageKey]);

  return [value, setValue];
};
